module.exports = __webpack_public_path__ + "static/media/map-bg-720.6e314932.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map-bg-720.jpg
// module id = 1398
// module chunks = 1